// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__IB1un"};